import BlogBannerTileItem from '~/shared/components/items-navigator/components/blog-banner-tile-item/blog-banner-tile-item';
import ExtendedTileItem from '~/shared/components/items-navigator/components/extended-tile-item/extended-tile-item';
import TileItem from '~/shared/components/items-navigator/components/tile-item/tile-item';
import { LIST_ITEM_TYPE } from '~/shared/constants';
import type { ItemDataType } from '~/shared/types/general-type';

const getTileItems = ({
  items,
  lng,
  pageToGo,
  readMoreText,
  uniqueCards,
  getTagLink,
  pageTagsToGo,
  isContainItemImage,
  t,
  itemType,
}: {
  isMobile: boolean;
  isContainItemImage: boolean;
  items: ItemDataType[];
  itemType: string;
  pageToGo: string;
  pageTagsToGo?: string;
  t: (key: string, options: { ns: string[] }) => string;
}) => {
  return items?.map((itemData: ItemDataType, i) => {
    let uniqueCard = null;
    const index = uniqueCards?.findIndex((card) => {
      return card?.index === i;
    });

    if (index >= 0) {
      uniqueCard = uniqueCards[index];
    }

    const type = uniqueCard ? uniqueCard?.itemType : itemType;

    return type === LIST_ITEM_TYPE.EXTENDED ? (
      <ExtendedTileItem
        key={itemData._id}
        lng={lng}
        readMoreText={readMoreText}
        getTagLink={getTagLink}
        pageToGo={pageToGo}
        isContainItemImage={isContainItemImage}
        pageTagsToGo={pageTagsToGo}
        data={itemData}
        t={t}
      />
    ) : type === LIST_ITEM_TYPE.BLOG_BANNER ? (
      <BlogBannerTileItem
        key={itemData._id}
        lng={lng}
        pageToGo={pageToGo}
        isContainItemImage={isContainItemImage}
        pageTagsToGo={pageTagsToGo}
        data={itemData}
        t={t}
      />
    ) : (
      <TileItem lng={lng} key={itemData._id} pageToGo={pageToGo} pageTagsToGo={pageTagsToGo} data={itemData} t={t} />
    );
  });
};

export default getTileItems;
